import type { MachineSetupRepository } from '../data/machine-setup-repository';
import type { CreateMachineRequest, CreateMachineResponse } from '../types/machine-setup-types';

export class CreateMachineUseCase {
  constructor(private readonly repository: MachineSetupRepository) {}

  async execute(request: CreateMachineRequest): Promise<CreateMachineResponse> {
    if (!request.machineName || request.machineName.trim() === '')
      throw new Error('Machine name is required');
    if (!request.machineTypeKey)
      throw new Error('Machine type is required');
    if (!request.actorId || request.actorId <= 0)
      throw new Error('Valid actor ID is required');

    const response = await this.repository.createMachine(request);
    if (!response.isSuccess) throw new Error(response.message || 'Failed to create machine');
    return response;
  }
}
